import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {AutorizacaoService} from "../services/autorizacao.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {RotaGuardClient} from "./auth-loja.guard";

@Injectable({
  providedIn: 'root'
})
export class AuthKDSGuard{
  constructor(private router: Router, private autorizacaoService: AutorizacaoService) {

  }

  canActivate( route: ActivatedRouteSnapshot,
               state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.autorizacaoService.fetchUser().pipe(
      map(user => {
        let queryParams: any = {t: state.url};

        if(user && user.id){
          if (RotaGuardClient.operadorKDS(user)) {
            return true;
          } else {
            queryParams.erro = `O Usuario "${user.nome} - ${user.email}" não tem permissão para acessar modulo KDS`
          }
        }

        this.router.navigate(['/admin/login'], {queryParams:  queryParams }).then(() => {
        });
        return false;
      })
    );
  }
}
